import { CdkAccordionItem } from '@angular/cdk/accordion';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import {
    matExpansionAnimations,
    MatExpansionPanelState,
} from '@angular/material/expansion';
import { PageMetadata } from '@app/router';

@Component({
    selector: 'ui-sidebar-accordion',
    templateUrl: './ui-sidebar-accordion.component.html',
    styleUrls: [
        './ui-sidebar-accordion.component.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [matExpansionAnimations.bodyExpansion],
})
export class UiSidebarAccordionComponent extends CdkAccordionItem {
    @Input()
    public isActive = false;

    @Input()
    public headerText = '';

    @Input()
    public headerTooltip = '';

    @Input()
    public fontIcon?: string;

    @Input()
    public svgIcon?: string;

    @Input()
    public itemTemplate!: TemplateRef<any>;

    @Input()
    public pages: PageMetadata[] = [];

    public get accordionState(): MatExpansionPanelState {
        return this.expanded ? 'expanded' : 'collapsed';
    }
}
